// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1819a5e3","845":"574b916e"}[chunkId] + ".chunk.js";
};